import { useParams } from "react-router-dom";
import {
  CreateProcurementDemandPageHeader,
  CreateProcurementDemandForm,
} from "./components";
import { useDemandById } from "@hooks/procurements/demand/useDemandById";
import { SingleDemandResponseType } from "@type/procurements/demand";

const CreateProcurementDemand = () => {
  const { id } = useParams();
  const { demandState } = useDemandById();
  const { getSingleData } = demandState;
  return (
    <div className="p-10">
      <CreateProcurementDemandPageHeader
        demand={id ? getSingleData : null}
        id={id}
      />
      <CreateProcurementDemandForm demand={id ? getSingleData : null} id={id} />
    </div>
  );
};

export default CreateProcurementDemand;
